import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface LaunchDarklyContext {
  account: {
    region: string;
    accountCode: string;
    type?: string;
  };
}

export const LAUNCH_DARKLY_CLIENT_ID = new InjectionToken<Observable<string>>(
  'LaunchDarklyClientIdProvider'
);

export const LAUNCH_DARKLY_CONTEXT = new InjectionToken<
  Observable<LaunchDarklyContext>
>('LaunchDarklyContextProvider');

export type Flag = string | { CI: string; CG: string };

export interface FlagsService {
  /** Use if it is possible for your component/service to be used in either a CG or CI context */
  getPlatformBooleanFlag$(
    flag: Flag,
    defaultValue?: boolean
  ): Observable<boolean>;
  /**
   * Legacy method for use in a CG context. Do not use if it is possible for your component/service to be used in either a CG or CI context
   *
   * The only exception is if you are in a non CG context and have explicitly injected the FlagsService for that context. */
  getBooleanFlag(flag: string, defaultValue?: boolean): boolean;
  whenReady(): Observable<boolean>;
}
